    export async function ensureNotificationPermission() {
        if (typeof window === "undefined" || !("Notification" in window)) return "denied";
        if (Notification.permission === "granted") return "granted";
        if (Notification.permission === "denied") return "denied";
        try { return await Notification.requestPermission(); } catch { return "denied"; }
    }

    export async function notify(title, opts = {}) {
        const perm = await ensureNotificationPermission();
        if (perm !== "granted") return false;
        try {
            const reg = await navigator.serviceWorker?.ready;
            if (reg?.showNotification) {
                await reg.showNotification(title, {
                    body: opts.body || "",
                    icon: opts.icon || "/icons/icon-192.png",
                    badge: opts.badge || "/icons/badge-72.png",
                    tag: opts.tag,
                    data: opts.data,
                    requireInteraction: !!opts.requireInteraction,
                    renotify: !!opts.renotify,
                    vibrate: opts.vibrate || [80, 20, 80],
                    actions: Array.isArray(opts.actions) ? opts.actions : undefined,
                    silent: !!opts.silent
                });
                return true;
            }
        } catch {}

        try {
            const sw = navigator.serviceWorker?.controller;
            if (sw) {
                sw.postMessage({ type: "show-notification", title, options: {
                        body: opts.body || "",
                        icon: opts.icon || "/icons/icon-192.png",
                        badge: opts.badge || "/icons/badge-72.png",
                        tag: opts.tag,
                        data: opts.data,
                        requireInteraction: !!opts.requireInteraction,
                        renotify: !!opts.renotify,
                        vibrate: opts.vibrate || [80, 20, 80],
                        actions: Array.isArray(opts.actions) ? opts.actions : undefined,
                        silent: !!opts.silent
                    }});
                return true;
            }
        } catch {}

        try { new Notification(title, { body: opts.body || "", icon: opts.icon || "/icons/icon-192.png", badge: opts.badge || "/icons/badge-72.png", tag: opts.tag }); return true; }
        catch { return false; }
    }
